module.exports = __webpack_public_path__ + "img/r-gri.4185f02d.svg";